export const ALERTS_NON_PLATED_ICON_MAP = {
  'Air Pollution Warning': 'alertpollution',
  'Air Pollution Watch': 'alertpollution',
  'Air Quality Advisory': 'alertpollution',
  'Air Quality Alert': 'alertpollution',
  'Air Quality Warning': 'alertpollution',
  'Air Quality Watch': 'alertpollution',
  'Air Stagnation Advisory': 'alertpollution',
  'Ashfall Advisory': 'alertash',
  'Ashfall Warning': 'alertash',
  'Avalanche Warning': 'alertsnow',
  'Avalanche Watch': 'alertsnow',
  'Blizzard Warning': 'alertsnow',
  'Blizzard Watch': 'alertsnow',
  'Blowing Dust Advisory': 'alertdust',
  'Blowing Dust Warning ': 'alertdust',
  'Brisk Wind Advisory': 'alertwindy',
  'Civil Danger Warning': '',
  'Civil Emergency Message': '',
  'Coastal Flood Warning': 'alertflood',
  'Coastal Flood Watch': 'alertflood',
  'Coastal Flood Advisory': 'alertflood',
  'Coastal Flood Statement': 'alertflood',
  'Coastal/Lakeshore Bulletin': '',
  'Dense Fog Advisory': 'alertfog',
  'Dense Smoke Advisory': 'alertsmoke',
  'Dust Storm Advisory ': 'alertdust',
  'Dust Storm Warning': 'alertdust',
  'Earthquake Warning': '',
  'Emergency Management Bulletin (Not in Sun)': '',
  'Evacuation Immediate Bulletin': '',
  'Excessive Heat Warning': 'alertheat',
  'Excessive Heat Watch': 'alertheat',
  'Extreme Cold Warning': 'alertcold',
  'Extreme Cold Watch': 'alertcold',
  'Extreme Wind Warning': 'alertwindy',
  'Fire Weather Warning': '',
  'Fire Weather Bulletin': '',
  'Fire Weather Watch': '',
  'Fire Warning': '',
  'Flash Flood Warning': 'alertflood',
  'Flash Flood Watch': 'alertflood',
  'Flood Advisory': 'alertflood',
  'Flood Watch': 'alertflood',
  'Flood Warning': 'alertflood',
  'Flood Bulletin': '',
  'Freeze Warning': 'alertfreeze',
  'Freeze Watch': 'alertfreeze',
  'Freezing Fog Advisory': 'alertfog',
  'Freezing Rain Advisory': 'alerticy',
  'Frost Advisory': 'alertfrost',
  'Hard Freeze Warning': 'alertfreeze',
  'Hard Freeze Watch': 'alertfreeze',
  'Hazardous Materials Warning': '',
  'Heat Advisory': 'alertheat',
  'High Surf Advisory': 'alertflood',
  'High Surf Warning': 'alertflood',
  'High Wind Warning': 'alertwindy',
  'High Wind Watch': 'alertwindy',
  'Hurricane Warning': 'alerthurricane',
  'Hurricane Watch': 'alerthurricane',
  'Hurricane Wind Warning': 'alerthurricane',
  'Hurricane Wind Watch': 'alerthurricane',
  'Ice Storm Warning': 'alerticy',
  'Lake Effect Snow Advisory': 'alertsnow',
  'Lake Effect Snow and Blowing Snow Advisory': 'alertsnow',
  'Lake Effect Snow Warning': 'alertsnow',
  'Lake Effect Snow Watch': 'alertsnow',
  'Lake Wind Advisory': 'alertwindy',
  'Lakeshore Flood Advisory': 'alertflood',
  'Lakeshore Flood Warning': 'alertflood',
  'Lakeshore Flood Watch': 'alertflood',
  'Lakeshore Flood Statement': '',
  'Local Area Emergency': '',
  'Ozone Action Day (Watch)': 'alertpollution',
  'Ozone Alert': 'alertpollution',
  'Ozone Warning': 'alertpollution',
  'Radiological Hazard Warning': '',
  'River Flood Warning': 'alertflood',
  'River Flood Watch': 'alertflood',
  'River Flood Advisory': 'alertflood',
  'Severe Thunderstorm Warning': 'alerttstorm',
  'Severe Thunderstorm Watch': 'alerttstorm',
  'Severe Weather Warning': '',
  'Shelter In Place': '',
  'Significant Weather Alert': '',
  'Significant Weather Advisory': '',
  'Snow Squall Warning': 'alertsnow',
  'Special Weather Statement': '',
  'Storm Surge Warning': 'alertflood',
  'Storm Surge Watch': 'alertflood',
  'The Weather Channel': '',
  'Tornado Warning': 'alerttornado',
  'Tornado Watch': 'alerttornado',
  'Tropical Storm Warning': 'alerttropicalstorm',
  'Tropical Storm Watch': 'alerttropicalstorm',
  'Tropical Storm Wind Warning': 'alerttropicalstorm',
  'Tropical Storm Wind Watch': 'alerttropicalstorm',
  'Tropical Weather Statement': 'alerttropicalstorm',
  'Tsunami Advisory': 'alerttropicalstorm',
  'Tsunami Watch': 'alerttropicalstorm',
  'Tsunami Bulletin': '',
  'Tsunami Warning': 'alerttropicalstorm',
  'Typhoon Warning': 'alerthurricane',
  'Typhoon Watch': 'alerthurricane',
  'Volcano Warning': '',
  'Weather Bulletin': '',
  'Wind Advisory': 'alertwindy',
  'Wind Chill Advisory': 'alertcold',
  'Wind Chill Warning': 'alertcold',
  'Wind Chill Watch': 'alertcold',
  'Winter Storm Warning': 'alertsnow',
  'Winter Storm Watch': 'alertsnow',
  'Winter Weather Advisory': 'alertsnow',
  'Winter Weather Bulletin': '',
} as const;
